<template>
  <Dialog v-model:visible="modalVisible" :modal="true" append-to="self">
    <template #header>
      <strong>
        <font-awesome-icon icon="person-burst" />
        Challenging Behaviour
      </strong>
    </template>
    <div v-if="modalVisible">
      <p>Thank you for logging an incident in the rota system.</p>
      <p>
        Reportable incidents must <em>also</em> be filed separately in PCS in
        line with CoActive staff guidelines.
      </p>
    </div>
    <template #footer>
      <button class="btn btn-outline-secondary" @click="modalVisible = false">
        I still need to do this
      </button>
      <button
        class="btn btn-outline-success"
        :disabled="loading"
        @click="setReportFiled"
      >
        <LoadingSpinner v-if="loading" class="m-0" />
        <span v-else> I have filed the separate report </span>
      </button>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "primevue/dialog";
import { ref } from "vue";
import { useStore } from "vuex";
import { Hub } from "aws-amplify/utils";
import { LoadingSpinner } from "@switchsystems/coactive-vue-lib";
import useFileChallengingBehaviourReportModal from "./useFileChallengingBehaviourReportModal";

const { modalVisible, activityId, clientId, report } =
  useFileChallengingBehaviourReportModal();
const store = useStore();
const loading = ref(false);

const setReportFiled = async () => {
  loading.value = true;
  const result = await store.dispatch(
    "rotaactivities/confirmIncidentReportFiled",
    {
      activityId: activityId.value,
      clientId: clientId.value,
      reportId: report.value.id,
    },
  );

  if (result === false) {
    // default error handling will have shown an error toast
    loading.value = false;
    return;
  }

  // re-query the activity, we don't get a returned object
  const act = await store.dispatch("rotaactivities/getRotaActivity", {
    id: activityId.value,
  });
  if (act === false) {
    // default error handling will have shown an error toast
    loading.value = false;
    return;
  }
  Hub.dispatch("activity", {
    event: "updated",
    data: act,
  });
  loading.value = false;
  modalVisible.value = false;
};
</script>
